import { createReducer, on } from '@ngrx/store';
import { AccessControlListApiActions } from './floor-acl.actions';
import { adapter, initialState } from './floor-acl.state';

export const floorAclReducer = createReducer(
  initialState,
  on(AccessControlListApiActions.floorAclLoaded, (state, { floorAcl }) => adapter.addOne(floorAcl, state)),
  on(AccessControlListApiActions.floorAclMemberPut, (state, { aclMember }) =>
    adapter.updateOne(
      {
        id: aclMember.resourceId,
        changes: {
          users: (state.entities[aclMember.resourceId]?.users ?? []).map((x) =>
            x.member === aclMember.member ? aclMember : x
          ),
        },
      },
      state
    )
  ),
  on(AccessControlListApiActions.floorAclGroupPut, (state, { aclGroup }) =>
    adapter.updateOne(
      {
        id: aclGroup.resourceId,
        changes: {
          groups: (state.entities[aclGroup.resourceId]?.groups ?? []).map((x) =>
            x.groupId === aclGroup.groupId ? aclGroup : x
          ),
        },
      },
      state
    )
  ),
  on(AccessControlListApiActions.floorAclGroupRemove, (state, { aclGroup }) =>
    adapter.updateOne(
      {
        id: aclGroup.resourceId || '',
        changes: {
          groups: (state.entities[aclGroup.resourceId || '']?.groups ?? []).filter(
            (x) => x.groupId !== aclGroup.groupId
          ),
        },
      },
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectFloorAclIds = selectIds;
export const selectFloorAcls = selectEntities;
export const selectAllFloorAcls = selectAll;
